// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/utils/routing.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/utils/src/routing.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo listto-app
//     node fleet/fleet.ts check --repo listto-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Routing utilities for handling search parameters.
 */

/**
 * Safely extracts a string parameter from a params record.
 * Handles both string and string[] cases by returning the first element
 * if the value is an array.
 */
export function getParam(
  params: Record<string, string | string[] | undefined>,
  key: string,
): string | undefined {
  const value = params[key];
  if (Array.isArray(value)) {
    return value[0];
  }
  return value;
}

/**
 * Returns a path safe to use as a `?redirect=...` target after login.
 * Rejects any auth-group path to prevent infinite loops.
 */
const AUTH_PATH_PATTERN = /^\/(login|register|forgot-password|reset-password)([/?#]|$)/u;

const PLACEHOLDER_ORIGIN = "https://placeholder.invalid";

/**
 * Only a path on this origin is a redirect target. The URL parser resolves
 * `//host`, `/\host` and tab-split variants to another origin, so comparing
 * origins catches them where a prefix check would not.
 */
function isSameOriginPath(path: string): boolean {
  return path.startsWith("/") && new URL(path, PLACEHOLDER_ORIGIN).origin === PLACEHOLDER_ORIGIN;
}

export function safeRedirectTarget(path: string | null | undefined): string {
  if (!path || !isSameOriginPath(path)) {
    return "/";
  }
  return AUTH_PATH_PATTERN.test(path) ? "/" : path;
}
